// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// RegenerateAPITokenUserSecretHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResultDTO from '../models/ResultDTO';

interface Request {
    apiTokenUserId: string | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            apiTokenUserId: null,
        },
        initValues);
    },
    apiTokenUserId: 'apiTokenUserId',
}

interface Result extends ResultDTO {
    apiName: string | null;
    secret: string | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            apiName: "",
            secret: "",
        },
        initValues);
    },
    apiName: 'apiName',
    secret: 'secret',
}

export { Request, Result };